import DropDown from "PFComponents/dropdown/dropdown";
import { useCurrentProfile } from "PFCore/hooks/queries/profile/use_current_profile";
import { Conversation } from "PFCore/types";
import { useTranslation } from "react-i18next";

import { buildChatMenuOptions } from "./chat_menu.utils";

export type ChatMenuProps = {
  conversation: Conversation;
  isFollowing: boolean;
  targetUrl: string | false;
  setSendOnEnter: (value: boolean) => void;
  showParticipants: () => void;
  handleFollowingChange: (follow: boolean) => void;
  handleChange: (fn: () => void) => void;
  handleInviteToChat: () => void;
  handleSendOnEnter?: (value: boolean) => void;
};

export const ChatMenu = ({
  conversation,
  showParticipants,
  targetUrl,
  handleChange,
  isFollowing,
  handleFollowingChange,
  setSendOnEnter,
  handleInviteToChat
}: ChatMenuProps) => {
  const { t } = useTranslation("core", { keyPrefix: "chat.menu" });
  const { data: currentProfile } = useCurrentProfile();

  const options = buildChatMenuOptions({
    t,
    conversation,
    currentProfileId: currentProfile.id,
    isFollowing,
    targetUrl,
    showParticipants,
    handleFollowingChange,
    handleInviteToChat,
    setSendOnEnter
  });

  return (
    <DropDown
      options={options}
      style={{
        width: 210,
        minWidth: 210,
        right: 8,
        top: 32,
        maxHeight: 200
      }}
      selectedIndex={-1}
      handleClose={() => {}}
      // TODO: [PROF-6268] Fix types in DropDown handleChange
      // @ts-ignore - Related to PROF-6268
      handleChange={handleChange}
    />
  );
};
